module.exports = __webpack_public_path__ + "static/media/table-blue.ee7c4d63.png";